import { IconProps } from './';

const defaultSize = 48;

export const VarianceIcon = ({ size, className }: IconProps) => {
  return (
    <svg
      className={className}
      width={size ?? defaultSize}
      height={size ?? defaultSize}
      viewBox="0 0 81 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.4998 7.16667C22.0998 7.16667 7.1665 22.1 7.1665 40.5C7.1665 58.9 22.0998 73.8333 40.4998 73.8333C58.8998 73.8333 73.8332 58.9 73.8332 40.5C73.8332 22.1 58.8998 7.16667 40.4998 7.16667ZM40.4998 67.1667C25.7998 67.1667 13.8332 55.2 13.8332 40.5C13.8332 25.8 25.7998 13.8333 40.4998 13.8333C55.1998 13.8333 67.1665 25.8 67.1665 40.5C67.1665 55.2 55.1998 67.1667 40.4998 67.1667ZM54.3998 49.7L50.7332 46.0333C53.0998 41.6 52.4998 36 48.7665 32.2667C46.4665 29.9667 43.4998 28.8333 40.4998 28.8333C40.3998 28.8333 40.2998 28.8667 40.1998 28.8667L43.8332 32.5L40.2998 36.0333L30.8665 26.6L40.2998 17.1667L43.8332 20.7L40.6332 23.9C44.8665 23.9333 49.0665 25.5 52.2998 28.7C57.9665 34.4 58.6665 43.2333 54.3998 49.7ZM50.1332 54.4L40.6998 63.8333L37.1665 60.3L40.3332 57.1333C36.1332 57.1 31.9332 55.4667 28.7332 52.2667C23.0332 46.5667 22.3332 37.7667 26.5998 31.3L30.2665 34.9667C27.8998 39.4 28.4998 45 32.2332 48.7333C34.5665 51.0667 37.6665 52.2 40.7665 52.1L37.1665 48.5L40.6998 44.9667L50.1332 54.4Z"
        fill="#FF9500"
      />
    </svg>
  );
};
